import React, { Component } from "react";
import { Grid, Container, Icon, Button } from "semantic-ui-react";

import imageVaral1 from "./../static/varal-1@8b75porc.png";
import imageVaral2 from "./../static/varal-2@8b75porc.png";
import Slider from "react-slick";
import { Animated } from "react-animated-css";
import { navigateToSection } from "./../js";

export default ({ type }) => {
  return <HeaderDesktop type={type} />;
};

const settings = {
  // dots: true,
  arrows: false,
  infinite: true,
  speed: 1000,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  swipe: true
};

class HeaderDesktop extends Component {
  state = {
    isHeader1Visible: false,
    isHeader2Visible: false
  };

  componentDidMount() {
    this.startAnimation1();
  }

  next = () => {
    this.slider && this.slider.slickNext();
  };
  previous = () => {
    this.slider && this.slider.slickPrev();
  };

  startAnimation1 = () => {
    setTimeout(() => {
      this.setState({ isHeader1Visible: true });
      setTimeout(() => {
        this.setState({ isHeader1Visible: false });
        this.next();
        this.startAnimation2();
      }, 3000);
    }, 2000);
  };

  startAnimation2 = () => {
    setTimeout(() => {
      this.setState({ isHeader2Visible: true });
      setTimeout(() => {
        this.setState({ isHeader2Visible: false });
        this.next();
        this.startAnimation1();
      }, 3000);
    }, 1000);
  };

  render() {
    const { type } = this.props;
    return (
      <Container
        fluid
        className={
          type ? "custom-container-fluid-mobile" : "ui-fluid-container"
        }
        style={{ backgroundColor: "#1c1d1e", width: "100%" }}
      >
        <Slider
          {...settings}
          ref={c => (this.slider = c)}
          style={{ marginBottom: "10px", width: "100%" }}
        >
          <div style={{ width: "100%" }}>
            <Grid
              verticalAlign="middle"
              style={{
                backgroundSize: "cover",
                backgroundImage: `url(${imageVaral1})`,
                // width: "100%",
                height: "650px",
                rezize: "both",
                margin: 0
              }}
            >
              <Grid
                container
                stackable
                verticalAlign="middle"
                centered
                className="custom-grid-mobile"
              >
                <Grid.Row
                  columns="equal"
                  textAlign="left"
                  verticalAlign="middle"
                >
                  <Grid.Column>
                    <Container>
                      <Animated
                        style={{
                          color: "#fff",
                          textTransform: "uppercase",
                          fontSize: type ? "1.1em" : "2.1em",
                          fontWeight: "bold",
                          textShadow: "2px 1px #000000"
                        }}
                        animationIn="fadeIn"
                        animationOut="fadeOut"
                        animateOnMount={false}
                        isVisible={this.state.isHeader1Visible}
                      >
                        <h1 style={{ fontSize: "2.1em", fontWeight: "bold" }}>
                          Seu varal atende suas necessidades?
                        </h1>
                      </Animated>
                    </Container>
                  </Grid.Column>
                  <Grid.Column>
                    <Container textAlign="center">
                      <Animated
                        style={{
                          color: "#f2711c"
                        }}
                        animationIn="fadeIn"
                        animationOut="fadeOut"
                        animateOnMount={false}
                        isVisible={this.state.isHeader1Visible}
                      >
                        <Icon
                          name="question circle outline"
                          size="massive"
                          style={{
                            color: "#fff"
                          }}
                        />
                      </Animated>
                    </Container>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid
              verticalAlign="middle"
              style={{
                backgroundSize: "cover",
                backgroundImage: `url(${imageVaral2})`,
                width: "100%",
                height: "640px",
                rezize: "both",
                margin: 0
              }}
            >
              <Grid
                container
                stackable
                verticalAlign="middle"
                centered
                className="custom-grid-mobile"
              >
                <Grid.Row
                  columns="equal"
                  textAlign="left"
                  verticalAlign="middle"
                >
                  <Grid.Column>
                    <Container>
                      <Animated
                        style={{
                          color: "#fff",
                          textTransform: "uppercase",
                          fontSize: type ? "1.1em" : "1.8em",
                          fontWeight: "bold",
                          textShadow: "2px 1px #000000"
                        }}
                        animationIn="fadeIn"
                        animationOut="fadeOut"
                        animateOnMount={false}
                        isVisible={this.state.isHeader2Visible}
                      >
                        <p style={{ fontSize: "1.8em", fontWeight: "bold" }}>
                          Deixe o passado para trás...
                        </p>
                        <p style={{ fontSize: "1.8em", fontWeight: "bold" }}>
                          Conheça nossa linha de produtos!
                        </p>
                      </Animated>
                    </Container>
                  </Grid.Column>
                  <Grid.Column>
                    <Grid columns="equal">
                      <Grid.Row>
                        <Container textAlign="center">
                          <Animated
                            style={{
                              color: "#f2711c"
                            }}
                            animationIn="fadeIn"
                            animationOut="fadeOut"
                            animateOnMount={false}
                            isVisible={this.state.isHeader2Visible}
                          >
                            <Button
                              primary
                              size={type ? "small" : "massive"}
                              onClick={() =>
                                navigateToSection("section-produtos")
                              }
                              className="button-custom"
                            >
                              Saiba Mais
                            </Button>
                          </Animated>
                        </Container>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid>
          </div>
        </Slider>
      </Container>
    );
  }
}
